import React from 'react';

const MultipleCheckbox = ({ data, onCheck, selected }) => {
  const toggleValue = (value) => {
    const updated = selected.includes(value)
      ? selected.filter((v) => v !== value)
      : [...selected, value];
    onCheck(updated);
  };

  return (
    <div className="flex flex-col gap-2">
      {data.map((item) => (
        <label key={item.id} className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selected.includes(item.value)}
            onChange={() => toggleValue(item.value)}
          />
          {item.value}
        </label>
      ))}
    </div>
  );
};

export default MultipleCheckbox;